import * as React from 'react';

export class MultilineTextField extends React.PureComponent<MultilineTextField.Props, {}> {

  public render() {
    return (
        <div className="tb-react-multiline-text-holder">
            <textarea className="tb-multiline-text" onChange={evt => this.updateInput(evt)} onKeyUp={evt => this.updateInput(evt)} disabled={this.props.disabled}
             placeholder={this.props.placeholder} tb-test-id={this.props.testId}/>
        </div>
    );
  }

  private updateInput(evt: any) {
    this.props.handleChange(evt.target.value);
  }
}

export namespace MultilineTextField {
  export interface Props {
    readonly handleChange: (userText: string) => void;
    readonly disabled: boolean;
    readonly placeholder?: string;
    readonly testId?: string;
  }
}
